module.exports = __webpack_public_path__ + "static/plaid-min-min-a489974ed922d1ecc8d4c74cba78ced1.png";